import { Box, Typography, Link, Divider, Stack, Grid } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

function Footer() {
  return (
    <Box
      component='footer'
      sx={{
        backgroundColor: '#252728',
        color: '#cccccc',
        padding: '50px 30px',
        boxSizing: 'border-box',
      }}
    >
      <Divider sx={{ backgroundColor: '#4c4c4c', marginBottom: '30px' }} />

      <Grid container spacing={4} justifyContent='center'>
        {/* LINKS */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant='subtitle1' fontWeight='bold' sx={{ mb: 2 }}>
            LINKS
          </Typography>
          <Stack spacing={1}>
            <Link component={RouterLink} to='/' sx={linkStyle}>
              Home
            </Link>
            <Link component={RouterLink} to='/pricing' sx={linkStyle}>
              Harga
            </Link>
            <Link component={RouterLink} to='/about-byd' sx={linkStyle}>
              Tentang Kami
            </Link>
            <Link component={RouterLink} to='/gallery' sx={linkStyle}>
              Galery
            </Link>
            <Link component={RouterLink} to='/test-drive' sx={linkStyle}>
              Test Drive
            </Link>
            <Link component={RouterLink} to='/contact' sx={linkStyle}>
              Kontak
            </Link>
            <Link
              href='https://instagram.com/bydbsdserpong'
              target='_blank'
              rel='noopener'
              sx={linkStyle}
            >
              Instagram
            </Link>
            <Link component={RouterLink} to='/privacy' sx={linkStyle}>
              Kebijakan Privasi
            </Link>
          </Stack>
        </Grid>

        {/* PILIHAN MOBIL */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant='subtitle1' fontWeight='bold' sx={{ mb: 2 }}>
            PILIHAN MOBIL
          </Typography>
          <Stack spacing={1}>
            <Link component={RouterLink} to='/jelajahi-dolphin' sx={linkStyle}>
              Dolphin
            </Link>
            <Link component={RouterLink} to='/jelajahi-atto' sx={linkStyle}>
              ATTO 3 2024
            </Link>
            <Link component={RouterLink} to='/jelajahi-seal' sx={linkStyle}>
              Seal
            </Link>
            <Link component={RouterLink} to='/jelajahi-m6' sx={linkStyle}>
              M6
            </Link>
            <Link component={RouterLink} to='/jelajahi-denzad9' sx={linkStyle}>
              Denza D9
            </Link>
            <Link
              component={RouterLink}
              to='/jelajahi-sealion-7'
              sx={linkStyle}
            >
              Sealion 7
            </Link>
            <Link component={RouterLink} to='/jelajahi-atto1' sx={linkStyle}>
              Atto1
            </Link>
          </Stack>
        </Grid>

        {/* KONTAK KAMI */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant='subtitle1' fontWeight='bold' sx={{ mb: 2 }}>
            KONTAK KAMI
          </Typography>
          <Typography variant='body2'>
            <strong>BYD BSD CITY TANGERANG</strong>
            <br /> BSD City Serpong Kavling De Park
            <br /> Jl. BSD Raya Utama, Lengkong Kulon, Kec. Pagedangan,
            Kabupaten Tangerang, Banten 15331
            <br /> Indonesia
          </Typography>
          <Typography variant='body2' sx={{ mt: 1 }}>
            <strong>Marketing:</strong> Junius
            <br /> <strong>Phone:</strong>{' '}
            <Link
              href='https://wa.me/6281286864825'
              target='_blank'
              rel='noopener'
              sx={linkStyle}
            >
              +62 812-8686-4825
            </Link>
          </Typography>
        </Grid>

        {/* TENTANG SAYA */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant='subtitle1' fontWeight='bold' sx={{ mb: 2 }}>
            Tentang Saya - Junius
          </Typography>
          <Typography variant='body2'>
            Marketing Mobil BYD di BSD Tangerang.
            <br /> Temukan kendaraan canggih dan eco-friendly bersama saya.
            Hubungi untuk test drive dan info lebih lanjut. Mari wujudkan
            berkendara hijau!
          </Typography>
          <Stack direction='row' spacing={1} mt={2}>
            <Link
              href='https://instagram.com/bydbsdserpong'
              target='_blank'
              rel='noopener'
              sx={iconStyle}
            >
              ig
            </Link>
            <Link
              href='https://wa.me/6281286864825'
              target='_blank'
              rel='noopener'
              sx={iconStyle}
            >
              wa
            </Link>
          </Stack>
        </Grid>
      </Grid>

      <Divider sx={{ backgroundColor: '#4c4c4c', marginY: '30px' }} />

      <Typography
        variant='body2'
        sx={{ fontSize: '14px', lineHeight: 1.5, mb: 1, textAlign: 'center' }}
      >
        Saya Junius, spesialis pemasaran mobil listrik <strong>BYD</strong> di
        BSD Tangerang. Saya siap bantu Anda memilih model BYD yang sesuai gaya
        hidup modern — seperti Seal, Dolphin, hingga Sealion 7. Hubungi saya
        untuk jadwal test drive dan penawaran khusus langsung dari dealer resmi{' '}
        <strong>BYD BSD Serpong</strong>.
      </Typography>

      <Typography
        variant='body2'
        sx={{ fontSize: '13px', lineHeight: 1.5, textAlign: 'center' }}
      >
        © {new Date().getFullYear()} BYD BSD Serpong. All Rights Reserved.
        Powered by{' '}
        <Link
          href='https://gumiho.world'
          target='_blank'
          rel='noopener noreferrer'
          sx={{
            color: '#cccccc',
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          gumiho.world
        </Link>
      </Typography>
    </Box>
  );
}

const linkStyle = {
  color: '#cccccc',
  textDecoration: 'none',
  fontSize: '14px',
  '&:hover': { color: '#FF6A00' },
};

const iconStyle = {
  width: 32,
  height: 32,
  borderRadius: '50%',
  backgroundColor: '#444',
  color: '#fff',
  fontSize: 14,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textDecoration: 'none',
  '&:hover': { backgroundColor: '#FF6A00' },
};

export default Footer;
